var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryFlowFillBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_123_10",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_123_10",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACxUlEQVR4nO3dsWoUQQCA4d/GRommFSvRdzAIQSSddnJ9IKXoK2ivpA34BkYfIBYKNlZWAX0AQdAu0e5SjCxsJEh2b+9mdmc2+/8w7d4xX2Z39m6TgJmZmZmZmZmZmZmZmS3qJjBzMKvnInvVGwkOQj0X2ROEfz+QglDW6hSE/AiCkH/iBSH/ZE8e5APwrIftdHXMj4Is95P2ErjU486wOvYrV0g3jJ/AZfqveo1fnrIWgxwwXO8FWQzydUCQb4J0O209HADjkdeQ7hf138AT4EYPENUxnwJ/BMl/nxC8D8k/SUGQ/BMTBMk/GaGA4ae95EcQhPwTLwjjB1ljoPwKl04gX4B1QShmhYShUFwhdAYZBEUQlgLpHUUQlgbpFUUQVgLpDWXsIHNgD9hO8H39LrDfMJpe/3PqLfFs5Bj3Es5F28SHoVDGDLJH2lYFSYoyZpAdygFJ9jzBmEGeUw7IMbAxdZAfiXc5+xEYd1O9iTGDBOAQ2AKuZgJJtjIuCkjIeB+SdGUIQhRILxhVrhCWBonGaDvHCcJSINHXjI36IIIQfQ1JsjKO64MJQhRIUgxBiN5lJTlNnX2xpryG0AkkKYYgRK+QpBiCMDxIG0bbqD4uiO1K/fHFYQF320WArIqRCuS0a8D3qYPEYKQGqXoxdZCDyDeRGmRn6iBr9deHpYC8njpILEpKkE3gpICJzQ7SBaXp8ZbdBI/PbNcr46SASS0G5HT7+anhxZryTp3+QNpQBGH4FdKGIgj5QM5DEYS8IP+jCEJ+kLMoglAGCAueOXWXxfAgbQmCIGHqp6y2HhcwEaGQUc1F9u4XMBGhkFF9Fpe96/VvIoWJj/lQfxigS+8KmJCQebyhoO5Efus49nEE3KKwtiaKcgQ8oNBuA28nck2Z16ep4lbGea3XO46L+q+QNuvNjJmZmZmZmZmZmZmZmbFcfwE1ubJYLAKBLAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryFlowFillBlack);
export default __webpack_public_path__ + "static/media/InventoryFlowFillBlack.4bacd6c3931bb8375a31752cea7370df.svg";
export { ForwardRef as ReactComponent };